import { makeStyles } from "@material-ui/styles";

const printStyles = makeStyles(() => ({
	newPage: {
		pageBreakBefore: "always !important"
	}
}));

export default printStyles;
